/* src/app/shared/input-modal/input-modal.component.scss */
.input-field {
  margin-top: 5px;
}
/*# sourceMappingURL=input-modal.component.css.map */
